export default {
  template:
    "<div><i :title='name' class='fa fa-x' :class='[icon, computedIconColorClass]' @click='click'></i><br></div>",
  data() {
    return {
      color: {
        enabled: "white",
        active: "#2ecc71",
        disabled: "gray"
      },
      iconColorClass: "icon-enabled",
      delay: 400
    };
  },
  methods: {
    click() {
      if (!this.disabled) {
        this.toggleAnimation();
        this.execute();
      }
    },
    toggleAnimation() {
      this.iconColorClass = "icon-active";
      setTimeout(() => {
        this.iconColorClass = "icon-enabled";
      }, this.delay);
    }
  },
  computed: {
    computedIconColorClass() {
      if (this.disabled) return "icon-disabled";
      return this.iconColorClass;
    }
  },
  created() {
    this.iconColorClass = "icon-enabled";
  }
};
